import { Reveal } from "@/lib/reveal";
import { FOUNDER_PHOTO } from "@/data/content";

export const Founder = () => {
  return (
    <section id="founder" className="relative py-20 lg:py-32 overflow-hidden" data-testid="founder-section">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute left-0 bottom-0 h-[420px] w-[420px] rounded-full bg-teal/10 blur-[150px]" />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* photo */}
          <Reveal className="order-first">
            <div className="relative mx-auto w-full max-w-md">
              <div className="relative overflow-hidden rounded-[2rem] bg-gradient-to-b from-navy-700/80 via-navy-800 to-navy-900 ring-1 ring-teal/15 shadow-[0_30px_80px_-30px_rgba(0,0,0,0.85)]">
                <div className="pointer-events-none absolute left-1/2 top-[38%] h-72 w-72 -translate-x-1/2 -translate-y-1/2 radial-glow" aria-hidden="true" />
                <img
                  src={FOUNDER_PHOTO}
                  alt="Kiki Savili, Founder of Aiga Enable, seated in a power wheelchair"
                  className="relative z-10 mx-auto w-full max-w-sm object-contain px-6 pt-8"
                  loading="lazy"
                />
              </div>
            </div>
          </Reveal>

          {/* copy */}
          <div>
            <Reveal>
              <span className="text-xs font-mono uppercase tracking-[0.24em] text-teal">Built from experience</span>
              <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
                Meet the Founder
              </h2>
            </Reveal>
            <Reveal delay={0.06}>
              <div className="mt-6">
                <p className="font-display text-2xl font-bold text-white" data-testid="founder-name">Kiki Savili</p>
                <p className="text-sm font-mono uppercase tracking-[0.18em] text-teal mt-1">Founder &amp; Director, Aiga Enable</p>
              </div>
            </Reveal>
            <Reveal delay={0.12}>
              <p className="mt-6 font-display text-lg font-semibold text-white">
                A new reality changed the way I saw accessibility.
              </p>
            </Reveal>
            <Reveal delay={0.18}>
              <p className="mt-4 text-lg text-slate-300 leading-relaxed">
                After a spinal cord injury, I had to adapt to a new reality and navigate everyday
                life in ways I had never experienced before. Accessibility looks different for
                everyone, and constantly having to explain my access needs made it feel, at times,
                easier to withdraw from the world and create a more manageable environment around me.
              </p>
            </Reveal>
            <Reveal delay={0.24}>
              <p className="mt-4 text-lg text-slate-300 leading-relaxed">
                That experience deepened my understanding of how important it is for places and
                services to recognise people as individuals. It showed me the value of accessibility
                support that feels more connected, personal and responsive — support that helps
                people feel understood without having to explain everything from the beginning each
                time.
              </p>
            </Reveal>
            <Reveal delay={0.3}>
              <p className="mt-6 text-lg text-slate-300 leading-relaxed">
                It made me ask:
              </p>
              <p className="mt-2 font-display text-lg font-semibold text-white">
                What if organisations and services were better equipped to understand and support people with disabilities?
              </p>
              <p className="mt-2 font-display text-lg font-semibold text-white">
                That question became the foundation for A-ID.
              </p>
            </Reveal>
            <Reveal delay={0.36}>
              <div className="mt-6 rounded-2xl glass p-5">
                <p className="text-base text-slate-200 leading-relaxed">
                  As Founder and Director of Aiga Enable, I am developing technology to make
                  accessibility more personal, connected and controlled.
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
